import React from 'react';
import { Outlet } from 'react-router-dom';
export default (function () {
    return (React.createElement("section", { className: "pt-2 pl-4 pr-4" },
        React.createElement(Outlet, null)));
});
